/*
  Emprendify — ajustes de UX para Tienda Vero Correa.

  1. Popup de Shopify Forms con doble toque en iPhone.
     El tema (Kalles, T4SThemeSP.fixHand) carga FastClick (assets/hand.min.js) solo en
     iPhone/iPad con ancho <= 1199 y lo engancha a document.body. FastClick no ve dentro
     del Shadow DOM de los widgets de apps y se come el primer toque: el popup se abre y
     se cierra recien al segundo. Con la clase "needsclick" en el host, FastClick deja
     pasar el toque (el tema ya hace lo mismo para la app Flashy).
     Si otro widget de app pide doble toque en iPhone, agregar su host al selector.
*/
(function () {
  var SELECTOR = 'shopify-forms-embed:not(.needsclick)';
  function markForms() {
    document.querySelectorAll(SELECTOR).forEach(function (h) { h.classList.add('needsclick'); });
  }
  markForms();
  new MutationObserver(markForms).observe(document.body, { childList: true, subtree: true });
})();
